import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './header.css'
import { nav } from '../../Components/data/data'
import LoginIcon from '@mui/icons-material/Login';
import SegmentIcon from '@mui/icons-material/Segment';
import CloseIcon from '@mui/icons-material/Close';

const Header = () => {

  const [navlist,setnavlist] = useState(false)
  return (
    <header>
      <div className="container flex" >
        <div className="logo">LOGO</div>
        <div className="nav">
          <ul className={navlist ? 'small' : 'flex'}>
            {nav.map((list, index) => {
              return <li key={index}>
                <Link to={list.path} >{list.text}</Link>
              </li>
            })}
          </ul>
        </div>
        <div className="button flex">
          <h4>
            <span>2</span> My List
          </h4>
          <button className='btn1 flex'>
            <LoginIcon className='icon' /> Sign In
          </button>
        </div>
        <div className="toggle">
          <button onClick={() => setnavlist(!navlist)}>
            {navlist ? <CloseIcon/> : <SegmentIcon /> }
          </button>
        </div>

      </div>
    </header>
  )
}

export default Header
